import GenericBffClient from 'Utils/httpClients/GenericBffClient';
import { DOMAIN, LoggerFactory } from 'Services/Logger';
import { UserVerificationResponse, VerificationEmailResponse, VerificationEmailTokenResponse } from 'Models/ConsumerEnablementBff/Verification';
import { mapToAurora } from 'Utils/mapToAurora';
import { SendOTPResponse } from 'Models/ConsumerEnablementBff/Otp';

const logger = LoggerFactory.getLogger(DOMAIN.CONSUMER_ENABLEMENT);

export class ConsumerEnablementBffV1 extends GenericBffClient {
  constructor() {
    super('CONSUMER_ENABLEMENT_BFF_API', '/api/v1/', { logger });
  }

  /**
   * Get the verification pending detail user
   *
   * @returns The outcome of the request
   */
  async getVerification(verification: string) {
    return this.get<UserVerificationResponse>(`verification/${verification}`).then(mapToAurora);
  }

  /**
   * Request a new email verification token
   */
  async getVerificationToken(verificationId: string) {
    return this.post<VerificationEmailTokenResponse>(`verification/token/${verificationId}`, {}).then(mapToAurora);
  }

  /**
   * Validates email verification token received
   */
  async validateVerificationEmailToken({ token }: { token: string}) {
    return this.post<VerificationEmailResponse>('verification/email', { token }).then(mapToAurora);
  }

  /**
   * Validates email verification otp received
   */
  async validateVerificationEmailOTP(
    { otp, verificationId }: { otp: string; verificationId: string},
  ) {
    return this.post('verification/otp', { otp, verification_id: verificationId }).then(mapToAurora);
  }

  async sendVerificationToken(
    { activityId, sendMethodName }: { activityId: string; sendMethodName: string},
  ) {
    return this.post<SendOTPResponse>('verification/send_otp', { activity_id: activityId, send_method_name: sendMethodName }).then(mapToAurora);
  }
}
